import { collection, onSnapshot, doc, setDoc, addDoc, deleteDoc } from "firebase/firestore";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, onAuthStateChanged, signOut } from "firebase/auth";
import { db, auth } from "@/fb.js";
import { config } from "@/utils/configuration/config";
import { getErrorMessageFromFirebaseError } from "@/utils/utils";

export default class ShipRepoFirebase {
  async getUsers(users, service) {
    console.log("UserRepoFirebase-getUsers from", config.firebaseConfig.usersCollectionName);
    onSnapshot(collection(db, config.firebaseConfig.usersCollectionName), (querySnapshot) => {
      const changes = querySnapshot.docChanges();

      changes.forEach(async (change) => {
        console.log("UserRepoFirebase-getUsers. Change = ", change);
        if (change.type === "added") {
          service.addNewUserFromRepo(users, change.doc.id, change.doc.data());
        } else if (change.type === "modified") {
          service.modifyUserFromRepo(users, change.doc.id, change.doc.data());
        } else if (change.type === "removed") {
          service.removeUserFromRepo(users, change.doc.id);
        }
      });
    });
  }

  editUser(userId, user) {
    console.log("UserRepoFirebase-editUser", userId, user);

    const userRef = doc(db, config.firebaseConfig.usersCollectionName, userId);

    var errors = "";
    try {
      setDoc(userRef, user);
    } catch (error) {
      console.log("Error", error);
      errors = getErrorMessageFromFirebaseError(error);
    }

    console.log("ShipRepoFirebase-editShip fin");
    return errors;
  }

  saveNewUser(user) {
    console.log("UserRepoFirebase-saveNewUser", user);

    var errors = "";
    try {
      addDoc(collection(db, config.firebaseConfig.usersCollectionName), user);
    } catch (error) {
      console.log("Error", error);
      errors = getErrorMessageFromFirebaseError(error);
    }

    return errors;
  }

  deleteUser(userId) {
    const userRef = doc(db, config.firebaseConfig.usersCollectionName, userId);
    deleteDoc(userRef);
  }

  async signin(service, data) {
    console.log("Sign in");
    service.loggedIn = true;
    await signInWithEmailAndPassword(auth, data.email, data.password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        service.selectedUser(user);
        // ...
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
      });
  }

  async createUser(service, data) {
    console.log("Create user");
    service.loggedIn = true;
    createUserWithEmailAndPassword(auth, data.email, data.password)
      .then((userCredential) => {
        const user = userCredential.user;

        // No se puede seleccionar el usuario todavía porque no se ha guardado
        // y por tanto el servicio no lo conoce
        // service.selectedUser(user);
        service.waitUserForSelectWhenCreated(user.uid);

        console.log("createNewUser received from firestore:", user);
        data.uid = user.uid;
        service.saveUser(data);
        //addUser()
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
      });
  }

  async loggout(service) {
    signOut(auth).then(() => {
      console.log("user signed out");
      service.selectedUser(null);
      service.loggedIn = false;
    });
  }

  stateuser() {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log("user logging in: ", user);
      } else {
        console.log("user logged out");
      }
    });
  }
}
